import { HomeComputerLaunchersChin, HomeComputerProjectChin, } from '#pplx/frontend/apps/ask/ask-composer/HomeComputerComposerChin.js';
import { createPluginFactory } from '#pplx/frontend/composer-sdk/plugins/createPluginFactory.js';
import { useMemo } from 'react';
const createHomeProjectPlugin = createPluginFactory({
    name: 'home-computer-project',
    capabilities: [
        {
            kind: 'slot',
            components: [
                {
                    slot: 'chin',
                    component: HomeComputerProjectChin,
                    visible: ({ isVisible }) => isVisible,
                },
            ],
        },
    ],
});
const createHomeLaunchersPlugin = createPluginFactory({
    name: 'home-computer-launchers',
    capabilities: [
        {
            kind: 'slot',
            components: [
                {
                    slot: 'chin',
                    component: HomeComputerLaunchersChin,
                    visible: ({ isVisible }) => isVisible,
                },
            ],
        },
    ],
});
export function useHomeComposerChinPlugins({ onFocus, onInsertMention, onRemoveMention, isVisible, showFreePreviewLabel, onProjectChange, project, projectSearchSource, }) {
    return useMemo(() => {
        if (import.meta.env.VITE_IS_SIDECAR_BUILD)
            return {};
        return {
            projectPlugin: createHomeProjectPlugin({
                isVisible,
                project,
                onProjectChange,
                projectSearchSource,
            }),
            launchersPlugin: createHomeLaunchersPlugin({
                isVisible,
                showFreePreviewLabel,
                onFocusInput: onFocus,
                onInsertMentionNode: onInsertMention,
                onRemoveMentionNode: onRemoveMention,
            }),
        };
    }, [
        isVisible,
        showFreePreviewLabel,
        onFocus,
        onInsertMention,
        onRemoveMention,
        onProjectChange,
        project,
        projectSearchSource,
    ]);
}
//# sourceMappingURL=useHomeComposerChinPlugins.js.map